import { makeStyles } from '@material-ui/core/styles';
import { drawerWidth, drawerCloseWidth } from '~/config/layout';

export default makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    minHeight: '100vh',
    overflow: 'hidden',
    marginLeft: drawerCloseWidth,
    width: `calc(100% - ${drawerCloseWidth}px)`,
  },
  contentShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));
